interface CachedUserData {
  email: string;
  displayName?: string;
  photoURL?: string;
  lastLogin: number; // timestamp
}

export class UserCacheService {
  private static readonly CACHE_KEY = 'invirtiendo_remembered_user';
  private static readonly CACHE_EXPIRY_DAYS = 30; // 30 días

  /**
   * Guarda los datos del usuario en localStorage
   */
  static saveUser(email: string, displayName?: string, photoURL?: string): void {
    try {
      const userData: CachedUserData = {
        email,
        displayName,
        photoURL,
        lastLogin: Date.now()
      };
      
      localStorage.setItem(this.CACHE_KEY, JSON.stringify(userData));
    } catch (error) {
      console.warn('Error saving user cache:', error);
    }
  }

  /**
   * Recupera los datos del usuario desde localStorage
   */
  static getRememberedUser(): CachedUserData | null {
    try {
      const cached = localStorage.getItem(this.CACHE_KEY);
      if (!cached) return null;

      const userData: CachedUserData = JSON.parse(cached);
      
      // Validar que no haya expirado
      const expiryTime = userData.lastLogin + (this.CACHE_EXPIRY_DAYS * 24 * 60 * 60 * 1000);
      if (Date.now() > expiryTime) {
        this.clearUser();
        return null;
      }

      return userData;
    } catch (error) {
      console.warn('Error reading user cache:', error);
      this.clearUser(); // Limpiar cache corrupto
      return null;
    }
  }

  /**
   * Limpia los datos del usuario del cache
   */
  static clearUser(): void {
    try {
      localStorage.removeItem(this.CACHE_KEY);
    } catch (error) {
      console.warn('Error clearing user cache:', error);
    }
  }

  /**
   * Verifica si hay un usuario recordado
   */
  static hasRememberedUser(): boolean {
    return this.getRememberedUser() !== null;
  }

  /**
   * Actualiza el timestamp de último login
   */
  static updateLastLogin(): void {
    const userData = this.getRememberedUser();
    if (userData) {
      this.saveUser(userData.email, userData.displayName, userData.photoURL);
    }
  }
}